export function number2currency(num) {
    return parseFloat(num.toFixed(2)).toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' })
}

export function numberFixed(num) {
    return parseFloat(num.toFixed(2))
}
